export const getStudentConfig = (data) => {
	const width = document.body.clientWidth
	let is_w = width / 1920;is_w=is_w>1?1:is_w
	const xAxis = {
		data: 'value',
		axisLabel: {
			formatter: '{value}',
			style: {


				textBaseline: 'top',
				fill: '#cdcac3',
				fontSize: is_w*18
			}
		},
		min: 0,
		max: 790,
		interval: 200,
		axisLine: {
			style: {
				stroke: '#cdcac3',
				lineWidth: 1,
				fontSize:is_w*18
			}
		},
		nameTextStyle: {
			fill: '#fff',
			fontSize: is_w*18

		},
		axisTick: {
			style: {
				stroke: '#cdcac3',
				lineWidth: 1,
				fontSize: is_w*18
			}
		}
	}
	const yAxis = [{

		data: [],
		axisLine: {
			style: {
				stroke: 'rgba(0,0,0,0)',
				lineWidth: 1
			}
		},
		splitLine: {
			show: false
		},
		axisLabel: {
			formatter: '{value}',
			style: {
				fill: '#cdcac3',
				fontSize: is_w*18
			}
		},
		nameTextStyle: {
			fill: '#fff',
			fontSize: is_w*18
		},
		axisTick: {
			show: false
		}
	}]


	let max = 0

	const series = [

		{
			name: '订单金额',

			data: [],
			label: {
				show: true,
				position: 'top',
				offset: [is_w*55, 0],
				//formatter: '¥{value}',
				formatter: (labelItem) => `¥${labelItem.value?Number(labelItem.value).toFixed(2):''}`,
				style: {
					fill: '#cdcac3',
					fontSize: is_w*18
				}
			},

			type: 'bar',
			barWidth: '50%',
			gradient: {
				//color: ['#e4ac3e', '#3b3734'],
				color: ['#e4ac3e','rgba(247,191,80,0.8)', 'rgba(247,191,80,0.7)','rgba(247,191,80,0.4)'],
			},
			animationCurve: 'easeOutBack'
		},

	]
	data.sort((a,b)=>Number(a.order_amount)-Number(b.order_amount))
	data.forEach(item => {


		let order_amount = Number(item.order_amount)
		let user = item.user

		if (order_amount > max) {
			max = order_amount
		}

		if (user) {
			let name =user.name.replace(/\d+/g, '')
			if(name){
				user.name = name.substring(0, 4)
			}else {
				user.name = user.name.substring(0, 4)
			}
			series[0].data.push(order_amount)
			yAxis[0].data.push(user.name)
		}


	})
	xAxis.max = Math.ceil(max * 1.15 / 1000) * 1000
	xAxis.interval = xAxis.max / 4

	return {xAxis, series, yAxis}
}
